/**
 * Strips the leading # from an anchor to create a valid id for HTML elements.
 * When provided with undefined, it returns undefined, allowing for optional anchors.
 * @param anchor Anchor with a leading # (e.g., "#section1") or undefined.
 * @returns String without the leading #, or undefined if the input is undefined.
 */
export function idFromAnchor(anchor: string): string;
export function idFromAnchor(anchor: undefined): undefined;
export function idFromAnchor(anchor: string | undefined): string | undefined;
export function idFromAnchor(anchor: string | undefined): string | undefined {
	return anchor?.replace(/^#/u, "");
}
